/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getProfiles.defs.js'
export { main as default } from './getProfiles.defs.js'
